<p-menubar [model]="items">
  <ng-template pTemplate="start">
    <a routerLink="/"><img src="assets/image/logo.png" height="40" class="p-mr-2"></a>
  </ng-template>
  <ng-template pTemplate="end">
    <p-menubar [model]="itemsProfile" [style]="{'border': '0px'}">
      <ng-template pTemplate="start">
        <!-- <span class="p-overlay-badge p-mr-2">
          <a (click)="op.toggle($event)">
            <i class="pi pi-bell" #toggleButton style="font-size: 1.5em"></i>
            <span class="p-badge" >{{badge}}</span>
          </a>
        </span> -->
        <span class="p-mr-2">
          <button type="button" class="p-button flex border-1 w-2rem h-2rem p-0 align-items-center justify-content-center transition-all transition-duration-300 min-w-0" (click)="showConfig()">
                    <i class="pi pi-palette"></i>
                </button>
        </span>
      </ng-template>
      <ng-template pTemplate="end">
        <!-- <a (click)="swicthLang()">
          <img src="assets/image/flag/icon-EN.png" height="20" class="p-mr-2" *ngIf="locale === 'en'">
          <img src="assets/image/flag/icon-VN.png" height="20" class="p-mr-2" *ngIf="locale === 'vi'">
        </a> -->
        <span class="p-overlay-badge p-mr-2">
          <a (click)="op.toggle($event)">
            <i class="pi pi-bell" #toggleButton style="font-size: 1.5em"></i>
            <span class="p-badge" *ngIf="listWarning.length !== 0">{{listWarning.length}}</span>
          </a>
        </span>
      </ng-template>
    </p-menubar>
  </ng-template>
</p-menubar>
<p-overlayPanel #op [showCloseIcon]="true" [style]="{width: '650px'}">
  <ng-template pTemplate>
      <p-table [scrollable]="true" [value]="listWarning" selectionMode="single" [(selection)]="selectedNhanVien" (onRowSelect)="onRowSelect($event)"
      [paginator]="true" [rows]="5" responsiveLayout="scroll" styleClass="p-datatable-striped p-datatable-sm">
          <ng-template pTemplate="header">
              <tr>
                  <th pSortableColumn="hoVaTen">Họ và tên<p-sortIcon field="hoVaTen"></p-sortIcon></th>
                  <th pSortableColumn="message">Thông báo<p-sortIcon field="message"></p-sortIcon></th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
              <tr [pSelectableRow]="rowData">
                  <td>{{rowData.hoVaTen}} - {{rowData.maNhanVien}}</td>
                  <td [ngSwitch]="rowData.type">
                    <span *ngSwitchCase="1">Sinh nhật ngày - {{rowData.datetime | date:'dd/MM/yyyy'}} !</span>
                    <span *ngSwitchCase="2">Hết hạn năng định ngày - {{rowData.datetime | date:'dd/MM/yyyy'}}</span>
                    <span *ngSwitchCase="3">Kết thúc HĐLĐ ngày - {{rowData.datetime | date:'dd/MM/yyyy'}}</span>
                    <span *ngSwitchCase="4">Dự kiến nâng bậc lương ngày - {{rowData.datetime | date:'dd/MM/yyyy'}}</span>
                  </td>
              </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td>
                    Không có thông báo nào
                </td>
            </tr>
        </ng-template>
      </p-table>
  </ng-template>
</p-overlayPanel>
<p-dialog header="Thông báo" [(visible)]="displayNoti" [modal]="true" [style]="{width: '50vw'}"
    [draggable]="false" [resizable]="false">
      <p-table [scrollable]="true" [value]="listWarning" selectionMode="single" [(selection)]="selectedNhanVien" (onRowSelect)="onRowSelect($event)"
        [paginator]="true" [rows]="5" responsiveLayout="scroll" styleClass="p-datatable-striped p-datatable-sm">
          <ng-template pTemplate="header">
              <tr>
                  <th pSortableColumn="hoVaTen">Họ và tên<p-sortIcon field="hoVaTen"></p-sortIcon></th>
                  <th pSortableColumn="message">Thông báo<p-sortIcon field="message"></p-sortIcon></th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
              <tr [pSelectableRow]="rowData">
                  <td>{{rowData.hoVaTen}} - {{rowData.maNhanVien}}</td>
                  <td [ngSwitch]="rowData.type">
                    <span *ngSwitchCase="1">Sinh nhật ngày - {{rowData.datetime | date:'dd/MM/yyyy'}} !</span>
                    <span *ngSwitchCase="2">Hết hạn năng định ngày - {{rowData.datetime | date:'dd/MM/yyyy'}}</span>
                    <span *ngSwitchCase="3">Kết thúc HĐLĐ ngày - {{rowData.datetime | date:'dd/MM/yyyy'}}</span>
                    <span *ngSwitchCase="4">Dự kiến nâng bậc lương ngày - {{rowData.datetime | date:'dd/MM/yyyy'}}</span>
                  </td>
              </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td>
                    Không có thông báo nào
                </td>
            </tr>
        </ng-template>
      </p-table>
</p-dialog>
